import React from 'react';
const flexNavIcon = () => {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_1400_5813)">
  <path d="M9 9L19 9C19.2652 9 19.5196 9.10536 19.7071 9.29289C19.8946 9.48043 20 9.73478 20 10C20 10.2652 19.8946 10.5196 19.7071 10.7071C19.5196 10.8946 19.2652 11 19 11L9 11C8.73478 11 8.48043 10.8946 8.29289 10.7071C8.10536 10.5196 8 10.2652 8 10C8 9.73478 8.10536 9.48043 8.29289 9.29289C8.48043 9.10536 8.73478 9 9 9ZM1 16L19 16C19.2652 16 19.5196 16.1054 19.7071 16.2929C19.8946 16.4804 20 16.7348 20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18L1 18C0.734784 18 0.480429 17.8946 0.292892 17.7071C0.105356 17.5196 6.42368e-08 17.2652 8.74228e-08 17C1.10609e-07 16.7348 0.105356 16.4804 0.292893 16.2929C0.480429 16.1054 0.734784 16 1 16ZM1 2L19 2C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3C20 3.26522 19.8946 3.51957 19.7071 3.70711C19.5196 3.89464 19.2652 4 19 4L1 4C0.734785 4 0.48043 3.89464 0.292894 3.70711C0.105357 3.51957 1.28816e-06 3.26521 1.31134e-06 3C1.33453e-06 2.73478 0.105357 2.48043 0.292894 2.29289C0.48043 2.10535 0.734785 2 1 2Z" fill="#5C5F62"/>
  <path d="M5.24537e-07 10L6 6.5359L6 13.4641L5.24537e-07 10Z" fill="#5C5F62"/>
  </g>
  <defs>
  <clipPath id="clip0_1400_5813">
  <rect width="20" height="20" fill="white" transform="translate(20 20) rotate(-180)"/>
  </clipPath>
  </defs>
  </svg>
  
};

export default flexNavIcon;


